export const INTERNAL = 'INTERNAL';
export const PUBLIC = 'PUBLIC';